module.exports = __webpack_public_path__ + "img/client-logos.b950d144.png";